import { LocationHistoryType } from 'src/types/location';

const getBackUrl = (
    locationHistory: LocationHistoryType[],
    defaultUrl: string,
    excludeUrl?: string,
    excludePatterns?: RegExp[]
): string => {
    const urlItem = locationHistory.find((item, index) => {
        if (index === 0) return false;

        const isExcludedUrl = item.pathname === excludeUrl;
        const matchesPattern = excludePatterns?.some(pattern => pattern.test(item.pathname));

        return !isExcludedUrl && !matchesPattern;
    });

    return urlItem?.pathname || defaultUrl;
};
export default getBackUrl;
